angular.module('app.admin.reports.reportService', [])
  .factory('app.admin.reports.reportService', [
    '$http', '$q', '$httpParamSerializerJQLike',
    function ($http, $q, $httpParamSerializerJQLike) {
      /**
       * @type {ReportService}
       */
      let service = {
        viewerships: null,
        loading: false,
        points: [],
        list: null,
        eventslist: null,
        error: null,
        _debounceRetrieve: _.debounce((deferred, params, callback) => {
          "use strict";
          /**
           * @param {*} data
           */
          let processData = function (data) {
            if (data.error) {
              service.error = data.error;
            }
            else if (data) {
              service.viewerships = data;

              angular.forEach(service.viewerships.aggregates, function (aggregate) {
                if (aggregate.dtegametimefixed) {
                  aggregate.dtegametimefixed = moment.unix(aggregate.dtegametimefixed).format('MMM DD, YYYY :: hh:mm A');
                }
              });

              angular.forEach(service.viewerships.data, function (datum) {
                let point = new google.maps.LatLng(Number(datum.latitude), Number(datum.longitude));
                service.points.push(point);
              });
            }

            if (typeof callback !== 'undefined') {
              callback();
            }
          };

          $http.get(window.location.api('/admin/reporting/viewerships/?' + params))
            .then(
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                processData(response.data);
                deferred.resolve(response);
              },
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                processData(response.data);
                deferred.resolve(response);
              }
            );

        }, 200),

        retrieve: function (params, callback) {
          service.loading = true;
          params = $httpParamSerializerJQLike(params);
          let deferred = $q.defer();
          service._debounceRetrieve(deferred, params, callback);
          return deferred.promise;
        },

        _debounceRetrieveFile: _.debounce((fileParams, deferred, params, callback) => {
          "use strict";
          /**
           * @param {*} data
           */
          let processData = function (data) {
            if (data.error) {
              service.error = data.error;
            }
            else if (data) {
              const blob = service.base64toBlob(data.data, data.mimetype);

              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              service.loading = false;
              link.download = fileParams.filename + "." + fileParams.type;
              link.click();
            }

            if (typeof callback !== 'undefined') {
              callback();
            }
          };

          let reportRoute = "";
          if (fileParams.type === "pdf") {
            reportRoute = "/admin/reporting/viewerships_pdf/?" + params;
          } else if (fileParams.type === "csv") {
            reportRoute = "/admin/reporting/viewerships_csv/?" + params;
          } else {
            alert('Invalid report type requested');
          }

          $http.get(window.location.api(reportRoute))
            .then(
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                processData(response.data);
                service.loading = false;
                deferred.resolve(response);
              },
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                processData(response.data);
                service.loading = false;
                deferred.resolve(response);
              }
            );

        }, 200),

        getReportFile: function (fileParams, params, callback) {
          service.loading = true;
          params = $httpParamSerializerJQLike(params);
          let deferred = $q.defer();
          service._debounceRetrieveFile(fileParams, deferred, params, callback);
          return deferred.promise;
        },

        base64toBlob: function (b64Data, contentType = "", sliceSize = 512) {
          const byteCharacters = atob(b64Data);
          const byteArrays = [];

          for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }

          const blob = new Blob(byteArrays, { type: contentType });
          return blob;
        },

        getSelections: function () {
          return $http.get(window.location.api('/admin/reporting/selections'))
            .then(
              function (response) {
                service.list = response.data;

                service.list.teams.sort(function (a, b) {
                  let nameA = a.leaguenickname.toUpperCase(); // ignore upper and lowercase
                  let nameB = b.leaguenickname.toUpperCase(); // ignore upper and lowercase

                  if (nameA < nameB) {
                    return -1;
                  }

                  else if (nameA > nameB) {
                    return 1;
                  }

                  else if (nameA === nameB) {
                    let nameA = a.label.toUpperCase(); // ignore upper and lowercase
                    let nameB = b.label.toUpperCase(); // ignore upper and lowercase

                    if (nameA < nameB) {
                      return -1;
                    }

                    else if (nameA > nameB) {
                      return 1;
                    }
                  }

                  // names must be equal
                  return 0;
                });
              },
            );
        },

        getEvents: function (params) {
          //params = $httpParamSerializerJQLike(params);
          return $http.get(window.location.api('/admin/reporting/events/' + params))
            .then(
              function (response) {
                service.eventslist = response.data;
              },
            );
        },

        clear: function () {
          service.viewerships = null;
          service.points.length = 0;
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/reports/reportService.js